@if (!isMobile) {
    <div class="location-container-wrapper">
        @if(!selectedBinInfo) {
            <div class='spinner-container'>
                <div class="spinner"></div>
            </div>
        }
        <div [ngClass]="{'hide-content': !selectedBinInfo}">
            <div class="location-container">
                <div class="location-container-item">
                    <div class="location-container-item-title">
                        <img alt="address" src="assets/images/binInfoPage/location.svg">
                        {{'LIST_COLUMNS.ADDRESS' | translate}}
                    </div>
                    <div class="location-container-item-content">
                        {{selectedBinInfo?.['Bin_location'].bin_address}}
                    </div>
                </div>
                <div class="location-container-item">
                    <div class="location-container-item-title">
                        <img alt="neighborhood" src="assets/images/binInfoPage/neighborhood.svg">
                        {{'LIST_COLUMNS.NEIGHBORHOOD' | translate}}
                    </div>
                    <div class="location-container-item-content">
                        {{selectedBinInfo?.['Bin_location'].bin_neighbourhood}}
                    </div>
                </div>
                <div class="location-container-item">
                    <div class="location-container-item-title">
                        <img alt="description" src="assets/images/binInfoPage/description.svg">
                        {{'LIST_COLUMNS.DESCRIPTION' | translate}}
                    </div>
                    <div class="location-container-item-content">
                        {{selectedBinInfo?.bin_description}}
                    </div>
                </div>
                @if(lastGpsStatus4Item || user_role_id == 2 || user_role_id == 5){
                <div class="location-container-item">
                    <div class="location-container-item-title">
                        <img alt="gps" src="assets/images/binInfoPage/gps.svg">
                        {{'LIST_COLUMNS.GPS' | translate}}
                    </div>
                    <div class="location-container-item-content">
                        @if(lastGpsStatus4Item){
                            {{'LIVE_INFO.LIVE_LAST_UPDATE' | translate }} {{ calcDiff(lastGpsStatus4Item.request_time) }}
                        }
                        @if(user_role_id == 2 || user_role_id == 5){
                            @if(gpsRequested && !displayGpsApproval){
                                <button class="disabled-gps-sync-btn gps-sync-btn tooltip-btn" triggers="click" [autoClose]="'outside'" type="button" [ngbTooltip]="tipContent" placement="top">
                                    {{'LIST_COLUMNS.REQUEST_GPS_SYNC' | translate}}
                                    <img alt="gps_sync" src="assets/images/binInfoPage/gps_sync_disabled.svg">                            
                                </button> 
                                <ng-template #tipContent>
                                    <div class="tooltip-content">
                                        {{'LIVE_INFO.GPS_SYNC_TIP' | translate}}
                                    </div>
                                </ng-template>     
                            }@else if(gpsRequested && displayGpsApproval){
                                <button class="disabled-gps-sync-btn gps-sync-btn tooltip-btn" triggers="click" [autoClose]="'outside'" type="button" [ngbTooltip]="tipContent" placement="top">
                                    {{'LIST_COLUMNS.REQUEST_GPS_SYNC' | translate}}
                                    <img alt="gps_sync" src="assets/images/binInfoPage/gps_sync_disabled.svg">                            
                                </button> 
                                <ng-template #tipContent>
                                    <div class="tooltip-content">
                                        {{'LIVE_INFO.GPS_SYNC_TIP_2' | translate}}
                                    </div>
                                </ng-template>   
                            }@else{
                                <button (click)="requestGpsSync()" class="enabled-gps-sync-btn gps-sync-btn">
                                    {{'LIST_COLUMNS.REQUEST_GPS_SYNC' | translate}}
                                    <img alt="gps_sync" src="assets/images/binInfoPage/gps_sync.svg">                            
                                </button> 
                            }   
                        }                                        
                    </div>
                </div>
                }
            </div>
            @if(displayGpsApproval && (user_role_id == 2 || user_role_id == 5)){
                <div class="gps-approval-container">
                    <div class="header-msg">
                        <img alt="gps_info" src="assets/images/binInfoPage/gps_info.svg">                            
                        {{'LIVE_INFO.GPS_APPROVAL_HEADER_MSG' | translate}}
                    </div>
                    <div class="body-container">
                        <div class="body-msg-container">                    
                            <div class="body-msg">{{selectedBinInfo?.Bin_location.bin_address}}</div>
                            <img [ngClass]="{'rotate_arrow':currentLang == 'iw' }" alt="new_gps" src="assets/images/binInfoPage/green_arrow.svg">                            
                            <div class="body-msg-bold">{{expectedApprovalAddress}}</div>
                        </div>
                        <div class="body-actions-container">
                            <div class="approval-btn" (click)="approveGpsResponse()">
                                <img alt="accept_gps" src="assets/images/binInfoPage/accept.svg">                            
                                {{'LIVE_INFO.APPROVE' | translate}}
                            </div>
                            <div class="reject-btn" (click)="rejectGpsResponse()">
                                <img alt="reject_gps" src="assets/images/binInfoPage/reject.svg">                            
                                {{'LIVE_INFO.REJECT' | translate}}
                            </div>
                        </div>
                    </div>
                </div>
            }
            @if(displayTheSameLocationAction){
                <div class="action-container location-background">
                    <div class="action-item">
                        <img alt="confirmation" src="assets/images/binInfoPage/confirmation.svg">                            
                        <div class="action-msg"> {{'LIVE_INFO.BIN_LOCATION_UPDATED_THE_SAME_LOCATION' | translate}} </div>
                    </div>
                    <img class="close-img" (click)="displayTheSameLocationAction = false" src="assets/images/reports/close.svg">
                </div>
            }
            @if(displaySuccessAction && !displayGpsApproval){
                <div class="action-container success-background">
                    <div class="action-item">
                        <img alt="approve" src="assets/images/binInfoPage/approve_ic.svg">                            
                        <div class="action-msg"> {{'LIVE_INFO.BIN_LOCATION_UPDATED_SUCCESSFULLY' | translate}} </div>
                    </div>
                    <img class="close-img" (click)="displaySuccessAction = false" src="assets/images/reports/close.svg">
                </div>
            }
            @if(displayRejectAction && !displayGpsApproval){
                <div class="action-container reject-background">
                    <div class="action-item">
                        <img alt="reject " src="assets/images/binInfoPage/reject_ic.svg">                            
                        <div class="action-msg"> {{'LIVE_INFO.BIN_LOCATION_REJECTED' | translate}} </div>
                    </div>
                    <img class="close-img" (click)="displayRejectAction = false" src="assets/images/reports/close.svg">
                </div>
            }
            <google-map class="google-map-container" [options]="mapOptions" (mapInitialized)="loadAPIWrapper($event)"></google-map>
            <div class="location-history-checkbox-container" rtlDiv>
                <input type="checkbox" id="locationHistory" [(ngModel)]="showLocationHistory" (ngModelChange)="onShowLocationHistoryChange()" />
                <label for="locationHistory">{{'LIVE_INFO.LOCATION_HISTORY' | translate}}</label>
            </div>
        </div>
    </div>
}

@if (isMobile) {

}
